module.exports = __webpack_public_path__ + "static/media/dekalb.63818c61.svg";